import { Loader2 } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';

interface DeleteConfirmSheetProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  submitting: boolean;
}

export function DeleteConfirmSheet({ open, onClose, onConfirm, submitting }: DeleteConfirmSheetProps) {
  return (
    <Sheet open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <SheetContent side="bottom" className="rounded-t-2xl">
        <SheetHeader>
          <SheetTitle>Excluir pedido</SheetTitle>
        </SheetHeader>
        <p className="py-4 text-sm text-slate-500">Tem certeza que deseja excluir este pedido? Esta ação não pode ser desfeita.</p>
        <div className="flex gap-3">
          <Button variant="outline" className="flex-1" onClick={onClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button variant="destructive" className="flex-1 gap-2" onClick={onConfirm} disabled={submitting}>
            {submitting && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
            Excluir
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
